/**
 * This file contains zod schemas for our builtinObjectClasses that are not
 * correctly / completely generated by the json-schema to zod converter.
 */

import * as z from 'zod';

const JSONTypeNames = z.enum(['boolean', 'number', 'string']);
export const SimpleJsonResponseFormat = z.object({type: JSONTypeNames});
export const ObjectJsonResponseFormat = z.object({
  type: z.literal('object'),
  properties: z.record(SimpleJsonResponseFormat),
});

export const LlmJudgeActionSpecSchema = z.object({
  action_type: z.literal('llm_judge'),
  model: z.enum(['gpt-4o-mini', 'gpt-4o']).default('gpt-4o-mini'),
  prompt: z.string(),
  response_schema: z.discriminatedUnion('type', [
    SimpleJsonResponseFormat,
    ObjectJsonResponseFormat,
  ]),
});
export type LlmJudgeActionSpec = z.infer<typeof LlmJudgeActionSpecSchema>;
